import { FormikProps } from "formik";
import { FormValues } from "./AdvanceType";
import { DatePicker } from "antd";
import dayjs from "dayjs";

 export const DateRangeRow: React.FC<{
  label: string;
  namePrefix: string;
  formik: FormikProps<FormValues>;
  displayFormat?: string;
}> = ({
  label,
  namePrefix,
  formik,
  displayFormat,
}) => {
  const format = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const handleQuickSelect = (days: number) => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - days);
    formik.setFieldValue(`${namePrefix}From`, format(past));
    formik.setFieldValue(`${namePrefix}To`, format(today));
  };

  return (
    <div className="date-row">
      <div className="row">
        <label className="label">{label}</label>
        <div className="date-container">
          <div className="date-input-wrapper">
            {displayFormat ? (
              <DatePicker
                className="inputdate"
                format={displayFormat}
                placeholder={displayFormat}
                value={
                  formik.values[`${namePrefix}From` as keyof FormValues]
                    ? dayjs(String(formik.values[`${namePrefix}From` as keyof FormValues]))
                    : null
                }
                onChange={(date) =>
                  formik.setFieldValue(
                    `${namePrefix}From`,
                    date ? date.format("YYYY-MM-DD") : "",
                  )
                }
              />
            ) : (
              <input type="date" {...formik.getFieldProps(`${namePrefix}From`)} className="inputdate" />
            )}
            {/* <FiCalendar className="icon" /> */}
          </div>
          <span className="separator">to</span>
          <div className="date-input-wrapper">
            {displayFormat ? (
              <DatePicker
                className="inputdate"
                format={displayFormat}
                placeholder={displayFormat}
                value={
                  formik.values[`${namePrefix}To` as keyof FormValues]
                    ? dayjs(String(formik.values[`${namePrefix}To` as keyof FormValues]))
                    : null
                }
                onChange={(date) =>
                  formik.setFieldValue(
                    `${namePrefix}To`,
                    date ? date.format("YYYY-MM-DD") : "",
                  )
                }
              />
            ) : (
              <input type="date" {...formik.getFieldProps(`${namePrefix}To`)} className="inputdate" />
            )}
            {/* <FiCalendar className="icon" /> */}
          </div>
        </div>
      </div>
      <div className="quick-link-bar">
        <button type="button" onClick={() => handleQuickSelect(7)} className="quick-link">Last 7 days</button>
        <span className="separator">|</span>
        <button type="button" onClick={() => handleQuickSelect(30)} className="quick-link">Last 30 days</button>
      </div>
    </div>
  );
};
